import {
  type DaperImages,
  type DaperStory,
  stringifyParams,
} from "@foundation/intercom-client";

export interface StoryWithImage extends DaperStory {
  image: DaperImages | undefined;
}

type TopicsStoriesApiRequest = {
  topicIds: string[];
  storyLimit?: number;
  storyIdsToExclude?: string;
  dedupeEnabled?: boolean;
};

export async function fetchTopicsStoriesFromApi(
  params: TopicsStoriesApiRequest,
  signal?: AbortSignal
): Promise<Record<string, StoryWithImage[]>> {
  const topicsStoriesResponse = await fetch(
    `/lineup-next/api/topicsStories?${stringifyParams(params)}`,
    { signal }
  );

  if (!topicsStoriesResponse.ok) {
    throw new Error(`Error when fetching from api/topicStories: ${params}`);
  }

  return (await topicsStoriesResponse.json()) as Record<
    string,
    StoryWithImage[]
  >;
}
